// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"3053af14","157":"ff103d1d","168":"12c6574c","442":"15b1b14b","503":"9db08a04","930":"746594e3"}[chunkId] + ".js";
};